import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';

@Component({
  selector: 'popup-message',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './popup-message.component.html',
  styleUrl: './popup-message.component.css'
})

export class PopupMessageComponent {
  @Input() type: string | null = null;
  @Input() message: string | null = null;
  @Output() close = new EventEmitter<void>()

  icons = Icons;
  closeMessage() {
    this.close.emit();
  }
}
